module.exports = __webpack_public_path__ + "img/50.5.COD.9e9c9c65.png";